<template>
    <div v-show="ready">
        <transition-group tag="div" :name="transition">
            <img
                v-for="(frame,i) in lazyFrames"
                v-show="i === current"
                :src="frame"
                :key="frame"
                class="mw-100"
                role="presentation"
                @load="handleFrameLoaded(i)"
            >
        </transition-group>
    </div>
</template>

<script>
    export default {
        props: {
            frames: Array,
            speed: {
                type: Number, // in ms
                default: 5000
            },
            transition: String,
            lazy: Boolean,
        },
        data() {
            return {
                loaded: this.frames.map(()=>false),
                started: false,
                current: 0
            }
        },
        computed: {
            ready() {
                return this.lazy ? this.loaded[0] : this.loaded.every(isLoaded => isLoaded);
            },
            lazyFrames() {
                if(this.lazy) {
                    return this.frames.filter((frame, i) => this.loaded[i] || i < this.current + 2);
                }
                return this.frames;
            },
        },
        methods: {
            handleFrameLoaded(i) {
                this.$set(this.loaded, i, true);
                this.$emit('loaded', i);
                if(this.ready && !this.started) {
                    this.started = true;
                    setTimeout(this.animate, this.speed);
                }
            },
            animate() {
                const nextIndex = (this.current + 1) % this.frames.length;
                if(this.loaded[nextIndex]) {
                    this.current = nextIndex;
                    setTimeout(this.animate, this.speed);
                } else {
                    this.$once('loaded', (i) => {
                        if(i === nextIndex) {
                            this.animate();
                        }
                    });
                }
            }
        },
    }
</script>